import { render, staticRenderFns } from "./CapturesView.vue?vue&type=template&id=74be73f6"
import script from "./CapturesView.vue?vue&type=script&lang=js"
export * from "./CapturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports